import React, { useEffect, useState } from 'react'
import RollerLoading from '../RollerLoading'
import { toast } from 'react-toastify'
import useInterval from '@/hooks/useInterval'

const InvoiceButton = ({ id, setIsInvoiceRequested, setSoftlandOrder }) => {

    const [isLoading, setIsLoading] = useState(false)

    const generateInvoice = () => {
        if (!isLoading) {
            setIsLoading(true)
            axios.get(`/manual-capture-DTE/${id}`)
                .then(response => {
                    setTimeout(() => {
                        setIsLoading(false)
                        if (response.data.status === 'success') {
                            toast.success('Boleta enviada a la cola')
                            setIsInvoiceRequested(true)
                            const invoicesRequested = JSON.parse(localStorage.getItem('invoices-requested') || '[]');
                            localStorage.setItem('invoices-requested', JSON.stringify([...invoicesRequested, id]))
                            checkInvoice()
                        }
                    }, 800)
                }).catch(error => {
                    console.error('Error en GenerateInvoice DTE: ', error)
                    setIsLoading(false)
                    setIsInvoiceRequested(false)
                    const invoicesRequested = JSON.parse(localStorage.getItem('invoices-requested') || '[]');
                    const invoicesFiltered = invoicesRequested.filter((order_id) => order_id !== id);
                    localStorage.setItem('invoices-requested', JSON.stringify(invoicesFiltered))
                })
        }
    }

    const checkInvoice = () => {
        const interval = setInterval(() => {
            axios.get(`/get-DTE/${id}`)
                .then(response => {
                    setTimeout(() => {
                        console.log(response)
                        if (response.data.status === 'success') {
                            toast.success('El folio ha sido creado correctamente')
                            setSoftlandOrder(response.data.softland_order)
                            setIsInvoiceRequested(false)
                            const invoicesRequested = JSON.parse(localStorage.getItem('invoices-requested') || '[]');
                            const invoicesFiltered = invoicesRequested.filter((order_id) => order_id !== id);
                            localStorage.setItem('invoices-requested', JSON.stringify(invoicesFiltered))
                            clearInterval(interval)
                        }
                    }, 800)
                }).catch(error => {
                    console.error('Error en GET DTE: ', error)
                    clearInterval(interval)
                })
        }, 5000)
    }

    return (
        <button
            className={`flex items-center ${isLoading ? 'bg-gray-400 text-gray-600 cursor-not-allowed pointer-events-none px-2' : 'bg-primary text-white py-2 px-4'} rounded-xl `}
            onClick={generateInvoice}
        >
            {
                isLoading ?
                    <RollerLoading />
                    :
                    <svg className="fill-white mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        height="1em"
                        viewBox="0 0 384 512">
                        <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z" />
                    </svg>
            }
            <p>{isLoading ? 'Procesando' : 'Emitir boleta'}</p>
        </button>
    )
}

export default InvoiceButton